import { Menu, MenuItem } from "@mui/material";
import { IdValueOption } from "../../types/common";
import { useState } from "react";
import { ExpandMore } from "@mui/icons-material";
import ThemedRadio from "./ThemedRadio";

type MenuRadioDropdownProps = {
    menuOptions: IdValueOption[];
    selectedOption: string;
    setSelectedOption: (option: string) => void;
}

const MenuRadioDropdown = ({
    menuOptions,
    selectedOption,
    setSelectedOption,
}: MenuRadioDropdownProps) => {
    // const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const open = Boolean(anchorEl);
    const selectedMenuOption = menuOptions.find(option => option.id === selectedOption);

    return (
        <div>
            <div
                className="border border-solid border-borderGrey py-1 px-2 flex items-center gap-2 text-xs text-greyishBlue rounded cursor-pointer"
                onClick={(e) => setAnchorEl(e.currentTarget)}
            >
                <div>{selectedMenuOption?.value || 'Instance #'}</div>
                <ExpandMore htmlColor="#94A1AF" className="!text-sm" />
            </div>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
            >
                {
                    menuOptions.map(option => {
                        return (
                            <MenuItem className="flex items-center !py-0 !pl-0" onClick={() => {
                                setSelectedOption(option.id);
                                setAnchorEl(null);
                            }}>
                                <ThemedRadio size="small" checked={option.id === selectedOption} />
                                <div className="text-xs flex items-center gap-2">
                                    <div>{option.value}</div>
                                    <div className="text-greyishBlue">{option.valueDetail}</div>
                                </div>
                            </MenuItem>
                        )
                    })
                }
            </Menu>
        </div>
    )
}

export default MenuRadioDropdown;